export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-36 bg-[var(--paper-soft)]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-10 lg:gap-16">
                <div className="col-span-12 lg:col-span-4 min-w-0">
                    <p className="overline text-[var(--slate)]">
                        About Medpax
                    </p>
                    <h2 className="font-display text-3xl sm:text-4xl md:text-5xl mt-6 text-[var(--ink)] leading-[1.05] break-words">
                        A small studio with a simple idea:
                        <span className="italic text-[var(--ink-line)]">
                            {" "}
                            software should feel human.
                        </span>
                    </h2>
                </div>

                <div className="col-span-12 lg:col-span-7 lg:col-start-6 min-w-0 space-y-6 text-[var(--slate)] text-lg leading-relaxed">
                    <p>
                        Medpax, LLC is an independent software company
                        headquartered in Rockwall, Texas. We build and publish
                        consumer applications under a single principle —
                        technology is best when it quietly gets out of the way.
                    </p>
                    <p>
                        Our team spends more time with intent than with
                        interfaces. We sketch, prototype, and rewrite until
                        every interaction earns its place. The result is a
                        growing family of calm, considerate products that people
                        actually keep on their home screen.
                    </p>
                    <p>
                        Medpax is the publisher of record for all of its
                        products on the Apple App Store and across the web, and
                        operates under U.S. federal and Texas state law.
                    </p>
                    <div className="pt-4 grid grid-cols-2 gap-6">
                        <div className="border-t border-[var(--line)] pt-4">
                            <p className="overline text-[var(--slate)]">
                                Principle
                            </p>
                            <p className="font-display text-xl text-[var(--ink)] mt-2">
                                Craft over noise
                            </p>
                        </div>
                        <div className="border-t border-[var(--line)] pt-4">
                            <p className="overline text-[var(--slate)]">
                                Practice
                            </p>
                            <p className="font-display text-xl text-[var(--ink)] mt-2">
                                Listen. Design. Refine.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
